class RestrictedShipping {
    constructor() {
      this.LOCAL_STORAGE_RESTRICTED_KEY = "greenworks-restricted-shipping";
      this.LOCAL_STORAGE_HAS_RESTRICTED_ZIP_KEY = "greenworks-has-restricted-zipcode";
      this.LOCAL_STORAGE_ZIPCODE_CONFIRMED_KEY = "greenworks-has-confirmed-zipcode";
      this.SESSION_STORAGE_RESTRICTED_ZIPS_KEY = "greenworks-restricted-zipcodes";
  
      this.selectors = {
        modal: "[restricted-shipping-modal]",
        modal_input: "[restricted-shipping-input]",
        modal_input_error: "[restricted-shipping-input-error]",
        modal_submit: "[restricted-shipping-submit]",
        modal_open: "[restricted-shipping-open]",
        modal_close: "[restricted-shipping-close]",
        restricted_product: "[restricted-shipping-product]",
        restricted_product_card: "[restricted-shipping-product-card]",
        restricted_product_card_att: "restricted-shipping-product-card",
        restricted_product_warning: "[restricted-product-warning]",
        restricted_variant_warning: "[restricted-variant-warning]",
        continue_shopping: "[view-alternatives]",
        results_restricted: "[restricted]",
        results_unrestricted: "[not-restricted]",
        variant_select: "#main-product .product-form select#product-id",
        variant_option_restricted: "[restrictedVariant]",
        variant_radios: "#main-product .product-form .variant-radios input[type='radio']",
        restricted_cart_items: ".cart [restricted-cart-item-warning]",
      };
  
      this.init()
    }
  
    init() {
        document.body.addEventListener('click', this.handleEvent.bind(this));
        document.body.addEventListener('keypress', this.handleKeyPress.bind(this));
        this.getCustomerZipCode();
        this.getRestrictedZipCodes();
        this.checkProduct();
        this.checkProductCards();
        this.checkCartItems();
        this.showWarningLabels('product');
    }

    handleEvent(e) {
        this.userOpenModal(e);
        this.closeModal(e);
        this.handleSubmit(e);
        this.setZipCodeConfirmed(e);
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.handleSubmit(e);
        }
    }

    // ===============================================================================================================================
    // Check to see if customer has change default address
    // Store in local storage the default address zip code and run a check to see if different, if so add to zip code to local storage

    // NEED TO SORT checkRestrictedVariant() function and checkRestricedVariant() function - not hiding option warning when not restricted change
    //================================================================================================================================

    checkCartItems() {
        if (this.hasRestrictedShipping() && this.checkZipCodeConfirmed()) {
            this.showWarningLabels('cart');
        } else {
            this.hideWarningLabels('cart');
        }
    }

    checkRestrictedVariant(select_el) {
        if (select_el) {
            let options = select_el.querySelectorAll('option');
            options.forEach((option) => {
                if (option.selected && option.dataset.restrictedVariant) {
                    if (this.checkZipCodeConfirmed() === true) {
                        this.showWarningLabels('variant');
                    } else {
                        this.openModal("variant");
                        this.hideWarningLabels('variant');
                    }
                } else {
                    this.hideWarningLabels('variant');
                }
            });
        }
    }

    userOpenModal(e) {
        let target = e.target.closest(this.selectors.modal_open);
        if (target) {
            e.preventDefault();
            this.openModal(target.getAttribute('data-type'));
        }
    }

    getCustomerZipCode() {
        if (window.QF.customer != null && window.QF.customer.default_address != null) {
            this.addToLocalStorage(window.QF.customer.default_address.zip);
        }
    }

    addToLocalStorage(zipCode) {
        let restrictedShipping = this.getRestrictedShipping();
        restrictedShipping = zipCode;
        localStorage.setItem(this.LOCAL_STORAGE_RESTRICTED_KEY, JSON.stringify(restrictedShipping));
    }

    getRestrictedShipping() {
        if (localStorage.getItem(this.LOCAL_STORAGE_RESTRICTED_KEY) == null || localStorage.getItem(this.LOCAL_STORAGE_RESTRICTED_KEY) == '') {
            return null;
        }
        let restrictedShipping = JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_RESTRICTED_KEY));
        return restrictedShipping ? restrictedShipping : [];
    }

    openModal(type) {
        const input = document.querySelector(this.selectors.modal_input);
        if (this.getRestrictedShipping() !== null) {
            input.value = this.getRestrictedShipping();
            document.querySelector(this.selectors.modal_submit).click();
        }
        input.focus();
        const modal = document.querySelector(this.selectors.modal);
        modal.classList.add('active');
        modal.setAttribute('data-type', type);
    }

    closeModal(e) {
        if (e.target.closest(this.selectors.modal_close) != null) {
            document.querySelector(this.selectors.modal).classList.remove('active');
        }
    }

    handleSubmit(e) {
        let target = e.target.closest(this.selectors.modal_submit);
        if (target || e.key === 'Enter') {
            e.preventDefault();
            document.querySelector(this.selectors.modal_input_error).classList.remove('active');
            let zip_code = document.querySelector(this.selectors.modal_input).value;
            if (zip_code.length == 0) {
                let message = document.querySelector(this.selectors.modal_input_error).getAttribute('data-message');
                document.querySelector(this.selectors.modal_input_error).innerHTML = message;
                document.querySelector(this.selectors.modal_input_error).classList.add('active');
                return;
            }
            zip_code = zip_code.replace(/\s/g, '');
            this.addToLocalStorage(zip_code);
            this.checkRestrictedShipping();
        }
    }

    getRestrictedZipCodes() {
        let restrictedZipCodes = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_RESTRICTED_ZIPS_KEY));
        if (restrictedZipCodes == null) {
            this.renderRestrictedZipCodes().then(() => {
                return restrictedZipCodes;
            });
        } else {
            return restrictedZipCodes;
        }
    }

    async renderRestrictedZipCodes() {
        fetch(window.Shopify.routes.root + "?sections=gt-restricted-zipcodes-metaobject")
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
              let zip_codes = data['gt-restricted-zipcodes-metaobject'].split('#');
              zip_codes = zip_codes[1].split(',');
              sessionStorage.setItem(this.SESSION_STORAGE_RESTRICTED_ZIPS_KEY, JSON.stringify(zip_codes));
          })
          .catch((error) => {
            console.error("Error:", error);
          });
    }

    checkRestrictedShipping() {
        let restrictedZipCodes = this.getRestrictedZipCodes();
        let customerZipCode = this.getRestrictedShipping();
        if (restrictedZipCodes.includes(customerZipCode)) {
            document.querySelector(this.selectors.results_restricted).style.display = 'flex';
            document.querySelector(this.selectors.results_unrestricted).style.display = 'none';
            localStorage.setItem(this.LOCAL_STORAGE_HAS_RESTRICTED_ZIP_KEY, JSON.stringify(true));
        } else {
            document.querySelector(this.selectors.results_unrestricted).style.display = 'flex';
            document.querySelector(this.selectors.results_restricted).style.display = 'none';
            localStorage.setItem(this.LOCAL_STORAGE_HAS_RESTRICTED_ZIP_KEY, JSON.stringify(false));
        }
    }

    checkProduct() {
        const restricted_product = document.querySelector(this.selectors.restricted_product);
        if (restricted_product) {
            if (!this.hasRestrictedShipping() && !this.checkZipCodeConfirmed() || this.checkZipCodeConfirmed() == false) {
                this.openModal("product");
                this.hideWarningLabels('product');
            } else if (this.hasRestrictedShipping() && this.checkZipCodeConfirmed()) {
                this.showWarningLabels('product');
            }
        }
    }

    checkProductCards() {
        if (this.hasRestrictedShipping() && this.checkZipCodeConfirmed()) {
            const targetNode = document.body;
            const config = { childList: true, subtree: true };

            const callback = function (mutationsList, observer) {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        for (const addedNode of mutation.addedNodes) {
                            if (addedNode.nodeType === 1 && (addedNode.classList.contains('product-card') || addedNode.querySelector('.product-card'))) {
                                window.restrictedShipping.showWarningLabels('product');
                            }
                        }
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }

    }
    
    hasRestrictedShipping() {
        let hasRestrictedShipping = JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_HAS_RESTRICTED_ZIP_KEY));
        if (hasRestrictedShipping == null || hasRestrictedShipping == false) {
            return false;
        } else {
            return true;
        }
    }

    setZipCodeConfirmed(e) {
        let target = e.target.closest(this.selectors.modal_close);
        let contine_shopping = e.target.closest(this.selectors.continue_shopping);
        if (target || contine_shopping) {
            localStorage.setItem(this.LOCAL_STORAGE_ZIPCODE_CONFIRMED_KEY, JSON.stringify(true));
            if (this.hasRestrictedShipping()) {
                const type = document.querySelector(this.selectors.modal).getAttribute('data-type');
                this.showWarningLabels(type);
            } else {
                this.hideWarningLabels('product');
                this.hideWarningLabels('variant');
            }
        }
    }

    checkZipCodeConfirmed() {
        let hasConfirmedZipCode = JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_ZIPCODE_CONFIRMED_KEY));
        return hasConfirmedZipCode ? hasConfirmedZipCode : false;
    }

    showWarningLabels(type) {
        if (type == 'product') {
            type = this.selectors.restricted_product_warning;
        } else if (type == 'variant') {
            type = this.selectors.restricted_variant_warning;
            let checked_radios = document.querySelectorAll(this.selectors.variant_radios + ':checked');
            if (checked_radios) {
                checked_radios.forEach(radio => {
                    if (this.hasRestrictedShipping() && this.checkZipCodeConfirmed()) {
                        radio.nextElementSibling.classList.add('active');
                        radio.nextElementSibling.querySelector('.restricted-variant-icon').classList.add('active');
                    }
                });
            }
        } else if (type == 'cart') {
            type = this.selectors.restricted_cart_items;
        }
        const warningLabels = document.querySelectorAll(type);
        if (this.hasRestrictedShipping() && this.checkZipCodeConfirmed()) {
            warningLabels.forEach((label) => {
                label.classList.add('active');
            });
        } else {
            warningLabels.forEach((label) => {
                label.classList.remove('active');
            });
        }
    }

    hideWarningLabels(type) {
        if (type == 'product') {
            type = this.selectors.restricted_product_warning;
        } else if (type == 'variant') {
            type = this.selectors.restricted_variant_warning;
        } else if (type == 'cart') {
            type = this.selectors.restricted_cart_items;
        }
        const warningLabels = document.querySelectorAll(type);
        warningLabels.forEach((label) => {
            label.classList.remove('active');
        });
    }
  
  }
  
  window.RestrictedShipping = RestrictedShipping;